import { normalize, schema } from 'normalizr';
import { ShopViewModel } from 'stageclip-common';

import { ById } from '../../store/normalizedState';

import * as EntityNormalizers from './entityNormalizers';

const { Entity } = schema;

export interface NormalizedShops {
  shops: ById<ShopViewModel>;
}

export const shopSchema = new Entity('shops');

export function normalizeShop(data: ShopViewModel): EntityNormalizers.NormalizedSingleEntity<NormalizedShops> {
  return normalize(data, shopSchema);
}

export function normalizeShopsArray(data: ShopViewModel[]): EntityNormalizers.NormalizedEntityArray<NormalizedShops> {
  return normalize(data, new schema.Array(shopSchema));
}
